/**
 * InMocean File Schemas Configuration - WITH GOOGLE SHEETS
 * Based on actual file samples from InMocean data
 */

export const INMOCEAN_FILE_SCHEMAS = {
  // 🆕 NEW: Google Sheets sync as first item
  google_sheets: {
    name: 'Google Sheets Import',
    icon: '📊',
    datasetId: 'inmocean_raw',
    tableName: 'google_sheets_data',
    maxSizeGB: 1,
    description: 'Auto-sync data from Google Sheets every 2 hours',
    type: 'sync', // Special type to indicate this is sync, not upload
    
    // Google Sheets specific configuration
    sheetConfig: {
      sheetId: '1PjCjraQLyCu6AtgOyRW7tu_LgTJ227Bz4zJqiMuHnf8',
      availableTabs: [
        { id: '1854005396', name: 'Main Data', description: 'Primary dataset' },
        { id: '0', name: 'Sheet1', description: 'First sheet' }
      ],
      syncInterval: '2 hours',
      autoSync: true
    },
    
    columns: [], // Will be determined dynamically from sheet
    requiredColumns: [] // No requirements - flexible
  },

  shipping: {
    name: 'Shipping Data',
    icon: '📦',
    datasetId: 'inmocean_raw',
    tableName: 'shipping',
    maxSizeGB: 1,
    description: 'Import/export shipping information',
    columns: [
      'IMG_REFERENCE#', 'Commercial Invoice', 'Ship To ID', 'Order', 'ITEM NUMBER',
      'COLOR CODE', 'HTS1_NBR', 'Booking ETD', 'Shipping ETD', 'Load Name',
      'POD', 'ORIGINAL ETA', 'CURRENT ETA', 'HOUSE B/L#', 'MASTER B/L#',
      'ASN#', 'ASN Date', 'CONTAINER#', 'Cntr Size', 'Cntr Height',
      'Carrier ID', 'Vehicle Name', 'Sum of Cartons', 'Sum of CBM', 'Sum of KGS',
      'Sum of Shp Qty', 'FOB PRICE', 'Division ID', 'COUNTRY OF ORIGIN', 'Manufacturer of Goods Name',
      'Vendor Name', 'LABEL CODE', 'Item Case Pack', 'STYLE TYPE', 'PACK TYPE',
      'ORDERED UNITS', 'LINE_PRICE', 'Line Number'
    ],
    requiredColumns: [
      'IMG_REFERENCE#', 'Commercial Invoice', 'Ship To ID', 'Order', 'ITEM NUMBER'
    ]
  },

  style_hts: {
    name: 'Style HTS Data',
    icon: '🏷️',
    datasetId: 'inmocean_raw',
    tableName: 'style_hts',
    maxSizeGB: 1,
    description: 'Style and HTS code information',
    strict: true,
    columns: [
      'SECTION','PO#','prod_type','season','TRANS_DATE','STAGE','PO_Line#','prod_num', 'prod_line', 'pod_div', 'pod_sty', 'pod_clr', 'pod_dim',
      'pod_lbl', 'size_po1_13', 'pod_QTY', 'pod_cost', 'term_rate', 'sln_sty',
      'sln_clr', 'sln_dim', 'sln_lbl', 'sln_hts', 'sln_hts_duty', 'sln_hs_descr',
      'siz', 'siz_qty', 'SLN_ratio', 'SLN_qty', 'rng_qty', 'sln_tQty',
      'sln_cost', 'sln_disc', 'sln_net', 'ord_dte', 'poh_shpd', 'fdte', 'tdte'
    ],
    requiredColumns: [
      'PO#', 'prod_num', 'sln_hts', 'pod_cost'
    ]
  },

  freight_charges: {
    name: 'Freight Cost Data',
    icon: '💰',
    datasetId: 'inmocean_raw',
    tableName: 'freight_charges',
    maxSizeGB: 1,
    description: 'Freight and shipping cost information',
    columns: [],
    requiredColumns: []
  },

  production_orders: {
    name: 'Production Orders',
    icon: '🏭',
    datasetId: 'inmocean_raw',
    tableName: 'production_orders_data',
    maxSizeGB: 1,
    description: 'Production order and manufacturing data',
    columns: [
      'Style', 'Color', 'Style Name', 'Program', 'Division', 'Stage'
    ],
    requiredColumns: [
      'Style', 'Color'
    ]
  },

  cost_sheet: {
    name: 'Cost Sheet',
    icon: '💵',
    datasetId: 'inmocean_raw',
    tableName: 'cost_sheet_data',
    maxSizeGB: 1,
    description: 'Product cost and pricing information',
    columns: [
      'Style Detail - Season', 'Division', 'CUST Name', 'Style', 'Color', 'Label',
      'Prd Cat Cost', 'Dm/Pk', 'Template', 'Category', 'Entry User', 'Entry Date',
      'Last Modified User', 'Last Modified', 'Frozen', 'Style Master Std Cost Upd Last Mod',
      'Style Master Std Cost Upd User', 'Update STD Cost', 'Program Name', 'Org Parent Name',
      'OFFICE Name', 'Group_Code5', 'Group_Code7', 'Org Group Name', 'Style Type',
      'Category Description', 'Color Name', 'CATEGORY Name', 'Final'
    ],
    requiredColumns: [
      'Style Detail - Season', 'Division', 'CUST Name', 'Style', 'Color', 'Prd Cat Cost'
    ]
  },

  duty_charges: {
    name: 'Duty Charges',
    icon: '📊',
    datasetId: 'inmocean_raw',
    tableName: 'duty_charges',
    maxSizeGB: 1,
    description: 'Customs duty and tariff information',
    columns: [],
    requiredColumns: []
  },

  rabi_invoices: {
    name: 'Rabi Invoices',
    icon: '🧾',
    datasetId: 'inmocean_raw',
    tableName: 'rabi_invoices_2',
    maxSizeGB: 2,
    description: 'Rabi invoice data for Power BI',
    columns: [],
    requiredColumns: []
  },

  rabi_invoices_v2: {
    name: 'Rabi Invoices V2 (Power BI)',
    icon: '📊',
    datasetId: 'inmocean_raw',
    tableName: 'rabi_invoices_2',
    maxSizeGB: 2,
    description: 'Rabi invoice with Pascal_Case headers and converted dates',
    columns: [],
    requiredColumns: []
  },

  production_cost_sheets: {
    name: 'Production Cost Sheets',
    icon: '📋',
    datasetId: 'inmocean_raw',
    tableName: 'production_cost_sheets',
    maxSizeGB: 2,
    description: 'Multi-tab production and costing data',
    type: 'multi_tab',

    tabs: {
      ERRORS: {
        name: 'ERRORS',
        tableName: 'production_errors',
        description: 'Error tracking and validation data',
        // 41-col shape aligned to the POD_errors.csv Azure export (CHA-332). Column ORDER matches the
        // pipe-delimited file exactly so the Azure direct-load maps positionally; keep in sync with the
        // production_errors table schema. `error` = CSV `err` (position 1); po_mgr stays LAST.
        columns: [
          'error', 'wip_ok', 'stage', 'div', 'sty', 'clr', 'lbl', 'dim',
          'A_PRICE', 'COST', 'prod_num', 'poh_office', 'lc_beneficiary', 'factory',
          'poh_coo', 'pod_loc', 'loc_country', 'prod_type', 'pod_pkey', 'shipto',
          'ship2_country', 'mg4_roy', 'mg6_frt', 'mg8_office', 'mg2_cust', 'mg12_line',
          'mp_qty', 'WIP_TOTAL', 'DueDate', 'ShpDate', 'hs_num', 'hs_num2', 'hs_num3',
          'cubic', 'sc_cubic', 'TOT_CARTON_VOL', 'MST_QTY', 'Terms', 'Terms_Ship', 'AgentComm', 'po_mgr'
        ],
        requiredColumns: ['prod_num', 'pod_pkey']
      },
      'OpenWIP-DUE': {
        name: 'OpenWIP-DUE',
        tableName: 'production_open_wip',
        description: 'Open WIP and due date tracking',
        columns: [
          'pod_pkey', 'WIP_OK', 'prod_num', 'open_seq', 'prod_line', 'ship_date', 'due_date',
          'trans_date', 'stage', 'last_stage', 'div', 'sty', 'clr', 'lbl', 'dim', 'size_code',
          'MP_qty', 'pod_qty_int', 'est_cases', 'mst_qty', 'min_multiple',
          'pod_PrdTyp',
          'lc_beneficiary', 'factory', 'pod_loc', 'shp2', 'roy_country', 'poh_sea', 'sc_season',
          'nFormula', 'f4', 'poh_office', 'mg8_office', 'mg4_pgm', 'mg6_ProductType',
          'mg2_customer', 'mg12L_Line', 'a_price', 'CountryOrigin', 'POH_country', 's_coo',
          'hs_num', 'quota', 'shipment_num', 'container#', 'comm_inv#', 'style_desc', 'cmt',
          'nPrdTyp', 'n300_cost', 'nFOBHA', 'n309_HApct', 'terms', 'terms_ship', 'n600_cost',
          'n301_frt', 'n304_Afrt', 'n305_Ifrt', 'n316_TarPct', 'n317_Tariff', 'n401_DutyPct',
          'n500_Duty', 'n501_AgtPct', 'n505_AgtCom', 'n601_Price', 'n605_RoyPct', 'n606_royalty',
          'n615_MarginPct', 'n609_GROSS', 'n610_MARGIN', 'n611_groroy', 'n612_marroy',
          'nRetailPrice', 'note_coo', 'po_mgr'
        ],
        requiredColumns: ['pod_pkey', 'prod_num']
      },
      '2025Rrcpts': {
        name: '2025Rrcpts',
        tableName: 'production_2025_receipts',
        description: '2025 receipts and shipping data',
        columns: [
          'pod_pkey', 'WIP_OK', 'prod_num', 'open_seq', 'prod_line', 'ship_date', 'due_date',
          'trans_date', 'stage', 'last_stage', 'div', 'sty', 'clr', 'lbl', 'dim', 'size_code',
          'MP_qty', 'pod_qty_int', 'est_cases', 'mst_qty', 'min_multiple',
          'pod_PrdTyp',
          'lc_beneficiary', 'factory', 'pod_loc', 'shp2', 'roy_country', 'poh_sea', 'sc_season',
          'nFormula', 'f4', 'poh_office', 'mg8_office', 'mg4_pgm', 'mg6_ProductType',
          'mg2_customer', 'mg12L_Line', 'a_price', 'CountryOrigin', 'POH_country', 's_coo',
          'hs_num', 'quota', 'shipment_num', 'container#', 'comm_inv#', 'style_desc', 'cmt',
          'nPrdTyp', 'n300_cost', 'nFOBHA', 'n309_HApct', 'terms', 'terms_ship', 'n600_cost',
          'n301_frt', 'n304_Afrt', 'n305_Ifrt', 'n316_TarPct', 'n317_Tariff', 'n401_DutyPct',
          'n500_Duty', 'n501_AgtPct', 'n505_AgtCom', 'n601_Price', 'n605_RoyPct', 'n606_royalty',
          'n615_MarginPct', 'n609_GROSS', 'n610_MARGIN', 'n611_groroy', 'n612_marroy',
          'nRetailPrice', 'note_coo', 'po_mgr'
        ],
        requiredColumns: ['pod_pkey', 'prod_num']
      }
    },

    requiredColumns: []
  },

  po_terms: {
    name: 'PO Terms',
    icon: '📋',
    category: 'Blue Cherry',
    section: 'Details',
    datasetId: 'inmocean_raw',
    tableName: 'po_terms_data',
    maxSizeGB: 1,
    description: 'Production order terms and shipment details',
    columns: [
      'Division', 'Production_Number', 'Ref_Number', 'Contractor_Factory',
      'Prd_Cst_Cntr_Name', 'Ship_Date', 'Due_Date', 'Total_Units', 'Prod_Value',
      'Terms', 'Season', 'Season_Name', 'Notes__Header', 'Ship_to',
      'Org_Ship_Date', 'Shpm_Type', 'Ship_Terms'
    ],
    requiredColumns: [
      'Production_Number', 'Ship_Date'
    ]
  },

  style_master: {
    name: 'Style Master Information',
    icon: '👔',
    category: 'Blue Cherry',
    section: 'Details',
    datasetId: 'inmocean_raw',
    tableName: 'style_master_data',
    maxSizeGB: 1,
    description: 'Style master data with fineline and department mapping',
    columns: [
      'Division', 'Season', 'Style', 'Country', 'Style_Name', 'Act', 'Price_A',
      'MDSE', 'CUST', 'CLASS', 'Program', 'Merch_Category', 'Style_Type',
      'FABRIC', 'OFFICE', 'Royalty', 'SizeRange', 'Sizes', 'Size_Allow', 'UOM',
      'Minimum_Multiple', 'Pack_Qty', 'Carton_Qty', 'Size_Avail', 'Line', 'Line_Name'
    ],
    requiredColumns: [
      'Style', 'Division'
    ]
  },

  inventory: {
    name: 'Inventory Data',
    icon: '🏷️',
    category: 'Inventory',
    section: 'Data',
    datasetId: 'inmocean_raw',
    tableName: 'inventory',
    maxSizeGB: 2,
    description: 'Inventory data with QOH, WIP, and availability',
    columns: [
      'SEA', 'LOC', 'DIV', 'cust_mg2', 'program_mg4', 'category_mg5', 'line_mg2',
      'mdse_mg', 'class_mg3', 'type_mg6', 'office_mg8', 'STY', 'STYLE_NAME', 'CLR',
      'LBL', 'DIM', 'SIZ', 'BKT', 'upc', 'Opn', 'Opn_lnk', 'tOpn', 'opn_', 'Pck',
      'Pck_lnk', 'tPck', 'tPck_', 'Inv', 'Inv_lnk', 'tInv', 'tInv_', 'Rtn', 'ADJ',
      'Rcvd', 'Rcvd_lnk', 'tRcvd', 'WIP', 'WIP_lnk', 'tWIP', 'wip_bal_intransit',
      'wip_intransit', 'tProd', 'QOH', 'tQOH', 'tQOH_', 'AVAIL_tQOH', 'OTS_tQOH_WIP',
      'OTS_shp2_loc', 'Book_', 'STD_COST', 'WAC_COST', 'A_PRICE', 'RET_PRICE',
      'ACTIVE_OK', 'SIZE_CODE', 'mp_totQty', 'mp_sizQty', 'mst_qty', 'inr_qty',
      'min_mult', 'f', 'SFC_CURR_CODE', 'SFC_RPTRATE'
    ],
    requiredColumns: [
      'STY', 'DIV'
    ]
  },

  hts_updates: {
    name: 'HTS Code Updates',
    icon: '📋',
    category: 'HTS',
    section: 'Data',
    datasetId: 'inmocean_raw',
    tableName: 'hts_updates',
    maxSizeGB: 2,
    description: 'HTS code updates with duty rates and style line details',
    columns: [
      'SECTION', 'PO_', 'prod_type', 'season', 'TRANS_DATE', 'STAGE', 'PO_line_',
      'pod_div', 'pod_sty', 'pod_clr', 'pod_dim', 'pod_lbl', 'size_po_3', 'siz',
      'pod_qty', 'pod_cost', 'term_rate', 'sln_sty', 'sln_clr', 'sln_dim', 'sln_lbl',
      'sln_hts', 'sln_hts_duty', 'sln_hs_descr', 'siz_qty', 'SLN_ratio', 'SLN_qty',
      'rng_qty', 'sln_tQty', 'sln_cost', 'sln_disc', 'sln_net', 'ord_dte', 'poh_shpd',
      'fdte', 'tdte', 'prod_num', 'PROD_LINE', 'open_seq', 'F', 'RA_section', 'RA_STY',
      'RA_CLR', 'RA_LBL', 'RA_DIM', 'ra_siz', 'ra_bkt', 'ra_POD_dim', 'ra_pod_lbl',
      'ra_siz_qty', 'ra_POD_cost_ea', 'ra_hts', 'ra_duty_pct', 'sql_pod_amt_ext',
      'sql_duty_ext', 'df', 'cs_pkey', 'curr_wac'
    ],
    requiredColumns: [
      'pod_sty', 'sln_hts'
    ]
  },

  openpt: {
    name: 'Open PT (Pick Tickets)',
    icon: '🚚',
    datasetId: 'inmocean_raw',
    tableName: 'openpt_csv',
    maxSizeGB: 1,
    description: 'Open pick ticket data for orderfile transformation',
    columns: [
      'Shipper', 'Consignee', 'PO_', 'Zero', 'PT_', 'Early_Date', '__PT_Date',
      'Cancel_Date', 'Status', 'N', 'Consignee_', 'Shipper_', '_Blank', '_DID',
      'Type', 'Shipper_Alpha', 'Pieces', 'Qty', 'Weight', '_Wave_', 'Route',
      'Pickup_Dt', 'Proj_', 'Call_Dt', '____D2C_Loc', '_Appt_Dt', 'Whs_Sts', 'Status_'
    ],
    requiredColumns: ['Shipper', 'Consignee', 'PO_', 'PT_', 'Status']
  },

  walmart_tms_bwi: {
    name: 'Walmart TMS — BWI',
    icon: '🛒',
    datasetId: 'inmocean_raw',
    tableName: 'walmart_tms_bwi_csv',
    maxSizeGB: 1,
    description: 'Walmart TMS routing data, BWI warehouse',
    columns: [
      'PO_Number', 'Load_ID', 'Load_Dest', 'Load_Dest_Type', 'Load_Dest_Address',
      'Load_P_U_Window_Start', 'Load_P_U_Window_End', 'MABD', 'Carrier_PU_Date',
      'Carrier_Due_Date', 'Carrier_Name', 'Industry_SCAC', 'Mode', 'Ship_Point',
      'Loading_Method', 'Cases', 'Weight', 'Cube', 'Pallets', 'Event_Code',
      'PO_Type', 'Department', 'Confirmed_Date', 'Held_Suspended', 'PO_Dest'
    ],
    requiredColumns: ['PO_Number', 'Load_ID', 'Load_Dest', 'Carrier_Name', 'Mode']
  },

  walmart_tms_dsdc: {
    name: 'Walmart TMS — DSDC',
    icon: '🛒',
    datasetId: 'inmocean_raw',
    tableName: 'walmart_tms_dsdc_csv',
    maxSizeGB: 1,
    description: 'Walmart TMS routing data, DSDC warehouse',
    columns: [
      'PO_Number', 'Load_ID', 'Load_Dest', 'Load_Dest_Type', 'Load_Dest_Address',
      'Load_P_U_Window_Start', 'Load_P_U_Window_End', 'MABD', 'Carrier_PU_Date',
      'Carrier_Due_Date', 'Carrier_Name', 'Industry_SCAC', 'Mode', 'Ship_Point',
      'Loading_Method', 'Cases', 'Weight', 'Cube', 'Pallets', 'Event_Code',
      'PO_Type', 'Department', 'Confirmed_Date', 'Held_Suspended', 'PO_Dest'
    ],
    requiredColumns: ['PO_Number', 'Load_ID', 'Load_Dest', 'Carrier_Name', 'Mode']
  },

  walmart_tms_img: {
    name: 'Walmart TMS — IMG',
    icon: '🛒',
    datasetId: 'inmocean_raw',
    tableName: 'walmart_tms_img_csv',
    maxSizeGB: 1,
    description: 'Walmart TMS routing data, IMG warehouse',
    columns: [
      'PO_Number', 'Load_ID', 'Load_Dest', 'Load_Dest_Type', 'Load_Dest_Address',
      'Load_P_U_Window_Start', 'Load_P_U_Window_End', 'MABD', 'Carrier_PU_Date',
      'Carrier_Due_Date', 'Carrier_Name', 'Industry_SCAC', 'Mode', 'Ship_Point',
      'Loading_Method', 'Cases', 'Weight', 'Cube', 'Pallets', 'Event_Code',
      'PO_Type', 'Department', 'Confirmed_Date', 'Held_Suspended', 'PO_Dest'
    ],
    requiredColumns: ['PO_Number', 'Load_ID', 'Load_Dest', 'Carrier_Name', 'Mode']
  },

  target: {
    name: 'Target TMS',
    icon: '🎯',
    datasetId: 'inmocean_raw',
    tableName: 'target_csv',
    maxSizeGB: 1,
    description: 'Target customer routing data. Note: bol column intentionally lowercase to match source.',
    columns: [
      'Purchase_Order_Number', 'Vendor_Name', 'Department', 'Address', 'Shipment_ID',
      'Load_Number', 'Assigned_SCAC', 'Executing_SCAC', 'PRO', 'Trip_ID',
      'Truck_Load_Optimization_Reference_ID', 'Status', 'Destination', 'Pickup_Date',
      'In_Yard_Goal_Date', 'Final_Routing_Expected_By', 'Cartons', 'Weight', 'Cube',
      'Pallet_Spaces', 'Commodity', 'bol', 'Appointment_Number', 'Created_By',
      'Review_By_Date', 'Last_Updated_By'
    ],
    requiredColumns: ['Purchase_Order_Number', 'Vendor_Name', 'Status', 'Pickup_Date']
  },

  // CHA-465 — Target's own item export, ingested so we can tell which pick orders still need
  // an upload. Parsed by ingestTargetItemExport, NOT the generic loader: four header rows before
  // data and four sheets where the item sheet is neither first nor largest.
  target_item_export: {
    name: 'Target Item Export',
    icon: '\ud83c\udfaf',
    datasetId: 'inmocean_raw',
    tableName: 'target_item_snapshot',
    // 50 MB, not 1 GB (CodeRabbit review). BOTH validation paths call
    // FileReader.readAsBinaryString first, and sheetRows caps worksheet rows only AFTER
    // the browser has read the whole file — so a permitted 1 GB export would exhaust
    // browser memory before upload. Target's real exports are ~1 MB (4,250 items).
    maxSizeGB: 0.05,
    description: "Target's Bulk Upload item export (Maintain or Setup). Snapshot of what Target currently holds.",
    columns: ['TCIN', 'DPCI', 'Barcode', 'H', 'W', 'D', 'Weight'],
    requiredColumns: ['TCIN'],
    // Target exports put guide/reference sheets before the actual item sheet. Client validation
    // must inspect the first non-reference sheet or every valid export fails as missing TCIN.
    sheetSelect: 'skipReference'
  },

  // CHA-463 — the weekly Matson carton-dims export. This is the ONLY source of physical
  // dimensions we have: nothing else in the warehouse carries per-each H/W/D or weight
  // (inventory.Dim holds style codes, production_2025_receipts.dim is ~90% null,
  // freight_cost_data.volume is empty on every row). CHA-459 derives per-each cube and weight
  // from the carton dims + units per carton, and CHA-460 matches them to SP27 items on order
  // to Target.
  //
  // The backend counterpart is the matson_carton_dims entry in getDefaultSchemas
  // (functions/bigqueryProcessor.js), which declares historyMode 'daily_snapshot' so each
  // weekly file APPENDS. Do not add a truncating mode here or there: the carton-weighted mode
  // that picks each item's spec is computed across weeks, so the history IS the input.
  matson_carton_dims: {
    name: 'Matson Carton Dims',
    icon: '📐',
    datasetId: 'inmocean_raw',
    tableName: 'matson_carton_dims',
    maxSizeGB: 1,
    description: 'Weekly Matson carton dimensions — the source for Target item dims (H/W/D/weight). Appends; every week is kept.',
    columns: [
      'SHPM CONTROL NBR', 'ASN Date', 'Commercial Invoice', 'WHSE CD', 'LABEL CODE',
      'Order', 'ITEM NUMBER', 'COLOR CODE', 'SIZE', 'CTN DIMS L x W x H (CM)',
      'Start Ctn', 'End Ctn', 'Cartons', 'CBM', 'QTY PER CTN', 'Range Qty',
      'UPC NO', 'GW PER CTN (KG)'
    ],
    // The four the resolver cannot work without: UPC is the join key to Target, and the
    // carton/qty/carton-count trio is what per-each cube and the mode are derived from.
    requiredColumns: ['UPC NO', 'CTN DIMS L x W x H (CM)', 'QTY PER CTN', 'Cartons']
  }

  // NOTE: Routing schemas have been moved to /src/apps/routing/config/routingSchemas.js
  // for multi-tenant SaaS support. Import from there instead.
};

// File type keys for easy iteration
export const FILE_TYPES = Object.keys(INMOCEAN_FILE_SCHEMAS);

// Get schema by file type
export const getFileSchema = (fileType) => {
  return INMOCEAN_FILE_SCHEMAS[fileType];
};

// Get all file schemas
export const getAllFileSchemas = () => {
  return INMOCEAN_FILE_SCHEMAS;
};

// Check if file type is a sync type (Google Sheets)
export const isSyncFileType = (fileType) => {
  const schema = INMOCEAN_FILE_SCHEMAS[fileType];
  return schema && schema.type === 'sync';
};

// Validation constants
export const VALIDATION_RULES = {
  MAX_FILE_SIZE_BYTES: 1024 * 1024 * 1024, // 1GB
  SUPPORTED_FORMATS: ['.csv', '.xlsx', '.xls'],
  SUPPORTED_MIME_TYPES: [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel'
  ]
};

// Helper functions
export function getFileTypeStats() {
  const types = Object.keys(INMOCEAN_FILE_SCHEMAS);
  const totalColumns = types.reduce((sum, type) => {
    return sum + INMOCEAN_FILE_SCHEMAS[type].columns.length;
  }, 0);
  
  return {
    totalFileTypes: types.length,
    totalColumns: totalColumns,
    averageColumnsPerType: Math.round(totalColumns / types.length),
    maxSizeGB: Math.max(...types.map(type => INMOCEAN_FILE_SCHEMAS[type].maxSizeGB))
  };
}

export function getExpectedColumns(fileType) {
  const schema = INMOCEAN_FILE_SCHEMAS[fileType];
  return schema ? schema.columns : [];
}

export function isValidFileType(fileType) {
  return fileType in INMOCEAN_FILE_SCHEMAS;
}

// Flexible column matching helpers
export function flexibleColumnMatch(actualColumn, expectedColumn) {
  const normalize = (str) => str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]/g, '')
    .replace(/\s+/g, '');
  
  return normalize(actualColumn) === normalize(expectedColumn);
}

export function findMatchingColumn(actualColumns, expectedColumn) {
  if (actualColumns.includes(expectedColumn)) {
    return expectedColumn;
  }
  
  for (const actualCol of actualColumns) {
    if (flexibleColumnMatch(actualCol, expectedColumn)) {
      return actualCol;
    }
  }
  
  return null;
}

export function normalizeColumnForBigQuery(columnName) {
  return columnName
    .replace(/[#/\s\-.]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .toUpperCase();
}

export function getBigQueryColumnMapping(fileType) {
  const schema = INMOCEAN_FILE_SCHEMAS[fileType];
  if (!schema) return {};
  
  const mapping = {};
  schema.columns.forEach(col => {
    mapping[col] = normalizeColumnForBigQuery(col);
  });
  return mapping;
}
